import {
  CompleteInboundsDocument,
  ConfirmInboundsDocument,
  FetchInboundingsDocument,
  InboundingFilterParameter,
  InProgressInboundsDocument,
  InputMaybe,
} from "../../generated-graphql/graphql";
import { OnInit } from "@angular/core";
import {
  DataService,
  ModalService,
  NotificationService,
  TypedBaseListComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Component } from "@angular/core";
import { NamilLocaleDatePipe } from "../../../localeDate";
import { Observable, map, distinctUntilChanged, take } from "rxjs";
import InboundExtendView from "./inbound-extends-view/view.component";
import { DataTable2Component } from "../../custom-table/data-table2.component";
import ExpandingDivComponent from "../../custom-table/components/expand_div/expand.component";
import InboundExpandContent from "./expand-content/content.component";
@Component({
  selector: "fan-club-page",
  templateUrl: "./page.component.html",
  standalone: true,
  imports: [
    SharedModule,
    NamilLocaleDatePipe,
    InboundExtendView,
    DataTable2Component,
    ExpandingDivComponent,
    InboundExpandContent,
  ],
})
export class PurchaseInboundingPage
  extends TypedBaseListComponent<typeof FetchInboundingsDocument, "inboundings">
  implements OnInit
{
  activeInboundingId$: Observable<string | null>;
  expandedIds: string[] = [];
  expandedRowIndex: number | null = null;

  setRowExpand(index: number) {
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null;
    } else {
      this.expandedRowIndex = index;
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.activeInboundingId$ = this.route.paramMap.pipe(
      map(params => params.get("contents")),
      distinctUntilChanged()
    );
  }

  routeFilter: InputMaybe<InboundingFilterParameter> = {};
  currentRoute: string

  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {
    super();
    this.route.url.pipe(take(1)).subscribe(res => {
      if (res.length > 0) {
        const url = res[0];
        switch (true) {
          case url.path.includes("waiting"):
            this.currentRoute = "waiting";
            this.routeFilter = {
              status: {
                in: ["Waiting", "InProgress", "Late"]
              },
            };
            break;
          case url.path.includes("complete"):
            this.currentRoute = "complete";
            this.routeFilter = {
              status: {
                eq: "Completed",
              },
            };
            break;
          case url.path.includes("confirm"):
            this.currentRoute = "confirm";
            this.routeFilter = {
              status: {
                eq: "Confirmed",
              },
            };
            break;
          default:
            // Handle the default case
            break;
        }
      }
    });

    super.configure({
      document: FetchInboundingsDocument,
      getItems: data => {
        console.log(data);

        return data.inboundings;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            ...this.routeFilter,
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addFilters([
      {
        name: "Status",
        type: { kind: "text" },
        filterField: "status",
        label: "Status",
      },
    ])
    .addDateFilters()
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("id", "DESC")
    .addSorts([
      { name: "id" },
      { name: "status" },
      { name: "createdAt" },
      { name: "updatedAt" },
    ]);

  confirm() {
    const selectedData: { id: string }[] = this.selectionManager.selection;
    const ids = selectedData.map(d => d.id);
    console.log(selectedData);
    this.dataService.mutate(ConfirmInboundsDocument, { ids }).subscribe(() => {
      this.notificationService.success("Inbounds confirmed");
      this.selectionManager.clearSelection();
      this.refresh();
    });
  }

  inProgress() {
    const selectedData: { id: string }[] = this.selectionManager.selection;
    const ids = selectedData.map(d => d.id);
    console.log(selectedData);
    this.dataService
      .mutate(InProgressInboundsDocument, { ids })
      .subscribe(() => {
        this.notificationService.success("Inbounds confirmed");
        this.selectionManager.clearSelection();
        this.refresh();
      });
  }

  closeContents() {
    const params = { ...this.route.snapshot.params };
    delete params.contents;
    this.router.navigate(["./", params], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  complete() {
    const selectedData: { id: string }[] = this.selectionManager.selection;
    const ids = selectedData.map(d => d.id);
    console.log(selectedData);
    this.dataService.mutate(CompleteInboundsDocument, { ids }).subscribe(() => {
      this.notificationService.success("Inbounds completed");
      this.selectionManager.clearSelection();
      this.refresh();
    });
  }

  completeDisabled() {
    return (
      this.selectionManager.selection.length <= 0 ||
      this.selectionManager.selection.every(i => i.status === "Completed") ||
      this.selectionManager.selection.every(i => i.status === "Confirmed")
    );
  }

  confirmDisabled() {
    return (
      this.selectionManager.selection.length <= 0 ||
      this.selectionManager.selection.every(i => i.status === "Confirmed")
    );
  }

  setInProgressDisabled() {
    return (
      this.selectionManager.selection.length <= 0 ||
      this.selectionManager.selection.every(i => i.status === "InProgress") ||
      this.selectionManager.selection.every(i => i.status === "Completed") ||
      this.selectionManager.selection.every(i => i.status === "Confirmed")
    );
  }
}
